import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_intercompany_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    branch_intercompany_settings_guid:fromDatatype.GuidDataFieldInterface;
    src_gendoc_server_doc_type:fromDatatype.VarcharDatatypeInterface;
    src_gendoc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    src_gendoc_hdr_guid:fromDatatype.GuidDataFieldInterface;
    tgt_gendoc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    tgt_gendoc_server_doc_type:fromDatatype.VarcharDatatypeInterface;
    tgt_gendoc_hdr_guid:fromDatatype.GuidDataFieldInterface;
    mode:fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid:fromDatatype.GuidDataFieldInterface;
    process_status:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    error_msg :fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_intercompany_processing_queue_RowClass implements bl_fi_mst_intercompany_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    branch_intercompany_settings_guid:fromDatatype.GuidDataFieldInterface;
    src_gendoc_server_doc_type:fromDatatype.VarcharDatatypeInterface;
    src_gendoc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    src_gendoc_hdr_guid:fromDatatype.GuidDataFieldInterface;
    tgt_gendoc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    tgt_gendoc_server_doc_type:fromDatatype.VarcharDatatypeInterface;
    tgt_gendoc_hdr_guid:fromDatatype.GuidDataFieldInterface;
    mode:fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid:fromDatatype.GuidDataFieldInterface;
    process_status:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    error_msg :fromDatatype.VarcharDatatypeInterface;
}